import React, { FC, ReactNode } from 'react';
import { container } from '../../styles/themes';
import { DefaultBsComponent, PayFitColor } from '../../types/module';
import { classNames } from '../../utils/style';
import { CodeColorProps, applyBgColor } from '../../utils/utils';
import { applyPadding } from './logic';


export type SpacingPresetValue = 'full' | 'half' | 'disabled';

export type SpacingCustomValue = {
  mobile: number;
  desktop: number;
};

export type SpacingValue = SpacingPresetValue | SpacingCustomValue;

export interface SectionProps extends DefaultBsComponent {
  backgroundColor?: PayFitColor;
  isDark?: boolean;
  topPadding?: SpacingValue;
  bottomPadding?: SpacingValue;
  isContained?: boolean;
  isAnimated?: boolean;
  children?: ReactNode;
  forceCodeColor?: CodeColorProps;
  id?: string;
  className?: string;
  blockType?: string;
}

export const Section: FC<SectionProps> = ({
  as: Component = 'div',
  backgroundColor = 'white',
  isDark,
  topPadding = 'full',
  bottomPadding = 'full',
  isContained = false,
  isAnimated = false,
  forceCodeColor,
  children,
  className,
  blockType,
  ...props
}) => {
  const paddingClasses = applyPadding({ topPadding, bottomPadding });

  return (
    <Component
      className={classNames(
        'Section',
        'relative',
        paddingClasses,
        className,
        !isContained &&
          applyBgColor(backgroundColor, isDark, '', forceCodeColor),
      )}
      {...props}
    >
      {isContained || isAnimated ? (
        <div
          className={classNames(
            isContained ? container : '',
            isAnimated ? 'animate-slide-in-top-30' : '',
            isContained &&
              applyBgColor(backgroundColor, isDark, '', forceCodeColor),
          )}
        >
          {children}
        </div>
      ) : (
        children
      )}
    </Component>
  );
};
